export default "__VITE_ASSET__C1D2sDuw__"